/**
 * Robust price-string → numeric parser.
 *
 * Handles all the shapes the AI/Travelpayouts/curated data throws at us:
 *   123                    → 123      (already a number)
 *   "€135"                 → 135
 *   "€135.74"              → 135.74
 *   "€120-€160/night"      → 120      (range → LOW end so quoted total is conservative)
 *   "€120–€160"            → 120      (em-dash variant)
 *   "From €299"            → 299
 *   "$1,245.00"            → 1245
 *   undefined / null / ""  → 0
 *
 * IMPORTANT: this used to be `.replace(/[^0-9.]/g, '')` which on a range
 * input "€120-€160/night" produced "120160" (concatenated both digit groups
 * → bogus €120,160 totals shown to users).
 */
export function parsePriceToNumber(value) {
  if (value === null || value === undefined) return 0;
  if (typeof value === 'number' && Number.isFinite(value)) return value;
  const s = String(value);
  // First numeric token wins. Comma is a thousands separator → drop, dot is decimal.
  const match = s.replace(/,/g, '').match(/(\d+(?:\.\d+)?)/);
  if (!match) return 0;
  const n = parseFloat(match[1]);
  return Number.isFinite(n) ? n : 0;
}

/** True if the price string represents a range like "€120-€160/night". */
export function isPriceRange(value) {
  if (typeof value !== 'string') return false;
  // Two numeric groups separated by a hyphen / en-dash / em-dash
  return /\d[\d.,]*\s*[-–—]\s*[€$£]?\s*\d/.test(value);
}

export default parsePriceToNumber;
